import dayjs from "dayjs";

import { Gig } from "../interfaces/Gig";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
const convertDateFormat = (date: Date | string, addTime: boolean = false) => {
  
  if (addTime) {
    return dayjs(date).utc().format("MM/DD/YYYY, hh:mm A");
  }
  return dayjs(date).utc().format("MM/DD/YYYY");
};

const getGigStartDate = (gig?: Gig | null) => {
  let startDate;
  if (gig?.multiDate?.startDate) {
    startDate = gig?.multiDate?.startDate;
  } else {
    startDate = gig?.date;
  }
  return startDate;
};

const getGigEndDate = (gig?: Gig | null) => {
  let endDate;
  if (gig?.multiDate?.endDate) {
    endDate = gig?.multiDate?.endDate;
  } else {
    endDate = gig?.date;
  }
  return endDate;
};

export { convertDateFormat, getGigStartDate, getGigEndDate };
